export const FETCH_WRANGLING_REPORT = "FETCH_WRANGLING_REPORT";
export const FETCH_WRANGLING_REPORT_SUCCESS = "FETCH_WRANGLING_REPORT_SUCCESS";
export const FETCH_WRANGLING_REPORT_FAILURE = "FETCH_WRANGLING_REPORT_FAILURE";
